import * as React from 'react';
import { Link } from 'react-router-dom';
import DisplayTimeByTimeStamp, { DisplayDepth, DisplayNdash } from '../components/Display';
import { Dive } from '../api/index';

export interface IStatsProps {
    dives: { userDives: Array<Dive> };
    type: string;
}

class Stats extends React.Component<IStatsProps> {
    getTimeSeconds(stringTime: string | undefined) {
        if (typeof stringTime !== 'string') {
            return null;
        }

        if (stringTime === '') {
            return 0;
        }

        let a = stringTime.split(':');
        return +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
    }

    prepareStatValues() {
        let divesCount = null;
        let maxDepth: number = 0;
        let maxDuration: string | undefined = '';

        // hodnoty ze seznamu ponoru
        if (
            this.props.dives !== undefined &&
            this.props.dives.userDives !== undefined
        ) {
            // celkova doba ponoru
            let totalDiveTime = 0;
            // pocet ponoru
            divesCount = this.props.dives.userDives.length;
            // nejlepsi hodnoty
            this.props.dives.userDives.forEach(dive => {
                // tslint:disable-next-line:triple-equals
                if (dive != undefined) {
                    if (
                        // tslint:disable-next-line:triple-equals
                        dive.maxDepth != undefined &&
                        dive.maxDepth > maxDepth
                    ) {
                        maxDepth = dive.maxDepth;
                    }
                    const temp1 = this.getTimeSeconds(dive.duration);
                    const temp2 = this.getTimeSeconds(maxDuration);
                    // tslint:disable-next-line:triple-equals
                    if (temp1 != undefined && temp2 != undefined) {
                        if (temp1 > temp2) {
                            maxDuration = dive.duration;
                        }
                    }

                    const durationSeconds = this.getTimeSeconds(dive.duration);
                    totalDiveTime += (durationSeconds != null ? durationSeconds : 0);
                }
            });

            return [
                {
                    name: 'Number of dives',
                    value: divesCount !== 0 ? divesCount : <DisplayNdash />,
                    type: 'air'
                },
                {
                    name: 'Deepest dive',
                    value: <DisplayDepth data={maxDepth} />,
                    type: 'maxDepth'
                },
                {
                    name: 'Longest dive',
                    value:
                        !maxDuration ? <DisplayNdash /> : maxDuration,
                    type: 'time'
                },
                {
                    name: 'Total dive time',
                    value:
                        totalDiveTime !== 0 ? (
                            <DisplayTimeByTimeStamp data={totalDiveTime} ignoreDays={true} />
                        ) : (
                            <DisplayNdash />
                        ),
                    type: 'total-time'
                }
            ];
        }

        return [];
    }

    render() {
        let data = this.prepareStatValues();

        return (
            <section>
                <div className={`${this.props.type}__stats cf`}>
                    <div className={`${this.props.type}__stats__subholder`}>
                        {data.map((stat, index) => (
                            <div
                                key={index}
                                className={`statCard statCard--${stat.type}`}
                            >
                                <div className="holder__table">
                                    <div className="holder__cell">
                                        <h3>{stat.name}</h3>
                                        <span>{stat.value}</span>
                                    </div>
                                </div>
                            </div>
                        ))}

                        <div className="statCard statCard--add-new-dive">
                            <Link to="/app/new-dive" />
                            <div className="holder__table">
                                <div className="holder__cell">
                                    <h3>Add</h3>
                                    <span>NEW LOG</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Stats;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Stats.tsx